import { render, staticRenderFns } from "./AppUploader.vue?vue&type=template&id=4dbc00e2&scoped=true&"
import script from "./AppUploader.vue?vue&type=script&lang=js&"
export * from "./AppUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc00e2",
  null
  
)

export default component.exports